mutation currentUserUpdate($email: String!, $first: String, $last: String, $wantsEmailNotifications: Boolean) {
  currentUserUpdate(email: $email, first: $first, last: $last, wantsEmailNotifications: $wantsEmailNotifications) {
    id
    email
    first
    last
    wantsEmailNotifications
  }
}
